export default "__VITE_ASSET__BcNU_uHy__"